export interface Document {
    id: string,
    filename: string
}

export enum EntityType {
    "Citizen" = "CITIZEN",
    "Birth Record" = "BIRTH_RECORD_APPLICATION",
    "Georgia DFCS Benefits" = "GEORGIA_DFCS_BENEFITS_APPLICATION",
    "Social Security" = "SOCIAL_SECURITY_APPLICATION",
    "Online Social Security" = "ONLINE_SOCIAL_SECURITY_APPLICATION",
    "Partner" = "PARTNER",
    "Partner User" = "PARTNER_USER",
    "Partner Site" = "SITE",
    "Inbound Mail Item" = "INBOUND_MAIL_ITEM",
}